import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";

import {
  AccountDetailContext,
  useAccountDetailContext,
} from "contexts/AccountDetailContext";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AccountBasicDetail from "./accountComponents/AccountBasicDetail";
import EnableDisableButton from "components/Shared/EnableDisableButton";

import {
  useGetAccountDetailQuery,
  useUpdateAccountMutation,
} from "store/services/accountApi";

import { useAppMeta } from "hooks";

const AccountDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Accounts", path: "/app/crm/account/list" },
    { title: "Account Detail" },
  ];

  // RTK Query
  const {
    data: accountDetail,
    isLoading: loadingAccount,
    error,
  } = useGetAccountDetailQuery(id);

  useAppMeta("Account Detail");

  return (
    <AccountDetailContext.Provider value={{ accountDetail, loadingAccount }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingAccount}
        toggleKey="ACCOUNT_DETAIL"
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <AccountBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </AccountDetailContext.Provider>
  );
};

export default AccountDetailScreen;

const PageActions = () => {
  const { accountDetail, loadingAccount } = useAccountDetailContext();

  // RTK Query
  const [updateAccount, { isLoading: updatingAccount }] =
    useUpdateAccountMutation();

  // methods
  const handleToggleAccountStatus = async () => {
    try {
      await updateAccount({
        _id: accountDetail?._id,
        isActive: !accountDetail?.isActive,
      }).unwrap();
      toast.info(
        `Account successfully ${
          accountDetail?.isActive ? "Disabled" : "Enabled"
        }!`
      );
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Account Status!");
    }
  };

  return (
    <div className="flex items-center gap-4">
      {false && (
        <EnableDisableButton
          isActive={accountDetail?.isActive}
          loading={loadingAccount || updatingAccount}
          onClick={handleToggleAccountStatus}
        />
      )}

      <Link to={`/app/crm/account/${accountDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
